import { FC } from "react"

export type NumberPostfixConfig = {
    endsWithOne: string
    endsBetweenTwoAndFour: string
    other: string
}

type Props = {
    value: number
    postfix: NumberPostfixConfig
}

export const NumberWithCorrectPostfix: FC<Props> = ({ value, postfix: { endsWithOne, endsBetweenTwoAndFour, other } }) => {
	const formattedValue = Math.abs(value) % 100
	const divReminder = formattedValue % 10

	let correctEnding = other

	if(formattedValue > 10 && formattedValue < 20) {
        correctEnding = other
    } else if(divReminder > 1 && divReminder < 5) {
        correctEnding = endsBetweenTwoAndFour
    } else if(divReminder == 1) {
        correctEnding = endsWithOne
    }

	return `${value} ${correctEnding}`
}
